<template>
  <div class="opertorbg">
    <STable
      ref="tableref"
      :url="url"
      :selection="false"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      labelWidth="120px"
    ></STable>
  </div>
</template>
<script>
export default {
  name: "pinpaixinghao",
  data() {
    return {
      url: "/battery/brand/page",
      columns: [
        {
          label: "品牌名称",
          prop: "brandName"
        },
        {
          label: "型号名称",
          prop: "modelName"
        },
        {
          label: "装机电量",
          prop: "electricity"
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: "修改",
            permission: "devicemanagement.brandModel.pageupdate",
            handle: res => {
              this.$router.push({
                path: "./reviseBrandModel",
                query: { data: res }
              });
            }
          },
          {
            label: "删除",
            style: "color:red",
            url: "/battery/brand/delete",
            method: "delete",
            permission: "devicemanagement.brandModel.delete",
            isConfirm: true,
            before: (index, record) => {
              let arr = [];
              arr.push(record.modelId);
              return {
                modelIds: arr
              };
            },
            handle: () => {
              this.$refs.tableref.queryTable();
            }
          }
        ]
      },
      query: [
        {
          label: "型号名称",
          prop: "modelName",
          placeholder: "请输入型号名称"
        },
        {
          label: "品牌名称",
          prop: "brandName",
          placeholder: "请输入品牌名称"
        }
      ],
      toolbar: [
        {
          label: "新增",
          permission: "devicemanagement.brandModel.pageadd",
          type: "success",
          handle: resp => {
            this.$router.push("./addBrandModel");
          }
        }
      ]
    };
  }
};
</script>
<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/brandModel.vue